import { jsxs, jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { twMerge } from "../../../node_modules/tailwind-merge/dist/bundle-mjs.js";
import Avatar from "../Avatar/Avatar.js";
const AvatarGroup = forwardRef((props, ref) => {
  const { avatars, max = 4, initialsOnly, className, imgProps, ...rest } = props;
  return /* @__PURE__ */ jsxs("div", { ...rest, ref, className: twMerge("flex items-center", className), children: [
    avatars.slice(0, max).map((row, i) => /* @__PURE__ */ jsx(
      Avatar,
      {
        ...row,
        initialsOnly,
        className: "hf-avatar-group -ml-2 first:ml-0",
        imgProps
      },
      i
    )),
    avatars.length > max && /* @__PURE__ */ jsx(
      Avatar,
      {
        alt: `+${avatars.length - max}`,
        bgColor: "rgb(var(--background-color))",
        className: "hf-avatar-group -ml-2 text-grayscale-400 font-semibold",
        initialsOnly: false
      }
    )
  ] });
});
export {
  AvatarGroup as default
};
//# sourceMappingURL=AvatarGroup.js.map
